// extracted by mini-css-extract-plugin
module.exports = {"form-submit":"style_form-submit__1NTB7"};